import {ICompany, ISettings, IUser} from "niteroi/packages/system/models/interfaces";

export default class Default {
    public static initSettings(): ISettings {
        return {
            systemCreatedAt: "",
            systemHost: window.location.hostname || "",
            systemId: "",
            systemLanguage: "en-US",
            systemLocale: "Europe/Berlin",
            systemName: "",
            systemOwner: "",
            systemPort: 443,
            systemProtocol: "https",
            systemRegion: "us-east-1",
            systemUpdatedAt: ""
        };
    }

    public static initUser(): IUser {
        return {
            theme: "S",
            userId: "",
            firstName: "",
            lastName: "",
            gender: "O",
            birthday: "",
            address: "",
            city: "",
            zipCode: "",
            country: "",
            email: "",
            phone: "",
            password: "",
            createdAt: "",
            updatedAt: "",
            isActive: true,
            locale: "",
            nationality: "",
            emailVerified: false,
            phoneVerified: false,
            companyId: ""
        };
    }

    public static initCompany(): ICompany {
        return {
            smtpPassword: "",
            smtpProvider: "default",
            smtpUsername: "",
            smtpIdentity: "",
            smtpRegion: null,
            address: "",
            city: "",
            companyId: "",
            companyName: "",
            country: "",
            email: "",
            logo: "",
            phone: "",
            registrationName: "",
            registrationNumber: "",
            taxId: "",
            vatId: "",
            iban: "",
            website: "",
            zipCode: "",
            parentId: "",
            createdAt: "",
            updatedAt: "",
            isActive: true,
            locale: ""
        };
    }
}
